import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContractDto } from 'src/app/models/contractDto';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { MovementDto } from 'src/app/models/MovementDto';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { ContractsService } from 'src/app/services/contracts.service';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { MovementService } from 'src/app/services/movement.service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-home-main',
  templateUrl: './home-main.component.html',
  styleUrls: ['./home-main.component.css']
})
export class HomeMainComponent implements OnInit {

  today = new Date();
  ActiveRequests: number = 0;
  PendingRequests: number = 0;
  ExpiringRequests: number = 0;
  ExpiredRequests: number = 0;
  PendingApprovals: number = 0;
  NewRequests: number = 0; 
  
  manPowerpendingRequestCount:number=0
  MovementNewRequestCount:number=0
  manPowerNewRequestCount:number=0
  movementNewRequestCount:number=0
  movementpendingRequestCount:number=0
  pendingManPowerRequestCount:number=0
  ManPower:ManPowerDto[]=[];
  movement:MovementDto[]=[];
  RejectedRequests: number = 0;
  ApprovedRequests: number = 0;
  MissingPO: number = 0;

  showRequestsMenu: boolean = false
  canAddRequest: boolean = false

  currentUser: any

  fullName: string = '';
  constructor(private contractService: ContractsService, private manPowerService:ManPowersService,private movementService:MovementService,private tokenService: TokenService, private router: Router) { }

  ngOnInit(): void {

    this.LoadBreakDown();
    this.getUserData();
  }
  async LoadBreakDown() {

    
    let resManPower = await this.manPowerService.getPendingManPower().toPromise();
    this.ManPower = <ManPowerDto[]>resManPower.responseData;
    this.manPowerpendingRequestCount = this.ManPower.length;


     let resNewManPower = await this.manPowerService.getNewManPowerRequest().toPromise();
    this.ManPower = <ManPowerDto[]>resNewManPower.responseData;
    this.manPowerNewRequestCount = this.ManPower.length;

    let resNewMovement = await this.movementService.getNewMovementRequest().toPromise();
    this.movement = <MovementDto[]>resNewMovement.responseData;
    this.MovementNewRequestCount = this.ManPower.length;



    
    let resMovement = await this.movementService.getPendingMovement().toPromise();
    this.movement = <MovementDto[]>resMovement.responseData;
    this.movementpendingRequestCount = this.movement.length;
   
    
    let resContracts = await this.contractService.getContractsByUser().toPromise();
    let resData = <ContractDto[]>resContracts.responseData;

    this.ActiveRequests = (resData.filter(x => x.status === "Active")).length;

    this.ExpiredRequests = (resData.filter(x => x.status === "Expired")).length;

    this.PendingRequests = ((resData.filter(x => x.status === "Pending")).length);

    this.NewRequests = ((resData.filter(x => x.status === "New")).length);

    this.RejectedRequests = ((resData.filter(x => x.status === "Rejected")).length);

    this.ApprovedRequests = ((resData.filter(x => x.status === "Approved")).length);

    this.MissingPO = ((resData.filter(x => x.expressApprovalRequired == true && x.poNumber == null && x.status === "Active")).length);


    let resExpiringRequests = resData.filter(x => x.status === "Approved" || x.status === "Active");
    if (resExpiringRequests != []) {
      let today = new Date();

      this.ExpiringRequests = resExpiringRequests.filter(x => (today.getMonth() - (new Date(x.expectedStartDate).getMonth())) == x.contractDuration && (new Date(x.expectedStartDate).getFullYear()) == today.getFullYear()).length;
    }

    
    let resPendingApproval = await this.contractService.getPendingContracts().toPromise();
    this.PendingApprovals = (<ContractDto[]>resPendingApproval.responseData).length;

  }

  

  getUserData(): void {

    try {
      

      const userData = this.tokenService.getInfo();
      this.currentUser = userData;

      var permissions = userData.permission;
      this.fullName = userData.profile.firstName;


      if (permissions) {

        let contractItem = permissions.find(i => i.permissionName === "Contracts");

        if (contractItem) {
          this.showRequestsMenu = contractItem.canRead;
          this.canAddRequest = contractItem.canAdd;
        }
        else {
          this.showRequestsMenu = false;
        }

      }
    }
    catch (e: unknown) { }


  }

  showFilteredRequests(status: string): void {
    this.router.navigate(['requests'], { state: { data: status } });
  }

  showFilteredManPowerRequests(status: string): void {
    this.router.navigate(['approvemanpowerrequests'], { state: { data: status } });
  }
  
  showFilteredMovementRequests(status: string): void {
    this.router.navigate(['approvemovementrequests'], { state: { data: status } });
  }

}
